var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttackSurfaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1467_17589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3372 1.8943L8.26936 -0.17356C8.19615 -0.19856 8.09794 -0.21106 7.99972 -0.21106C7.90151 -0.21106 7.80329 -0.19856 7.73008 -0.17356L1.66222 1.8943C1.51401 1.9443 1.39258 2.11573 1.39258 2.27287V10.8872C1.39258 11.0443 1.49436 11.2514 1.61758 11.3497L7.77294 16.1461C7.83544 16.1943 7.91579 16.2193 7.99794 16.2193C8.08008 16.2193 8.16222 16.1943 8.22294 16.1461L14.3783 11.3497C14.5015 11.2532 14.6033 11.0461 14.6033 10.8872V2.27287C14.6069 2.11573 14.4854 1.94608 14.3372 1.8943ZM13.3211 10.5443L7.99972 14.6907L2.67829 10.5443V2.90858L7.99972 1.0943L13.3211 2.90858V10.5443ZM6.05151 8.30323L4.66758 9.68716C4.64099 9.71401 4.62608 9.75026 4.62608 9.78805C4.62608 9.82583 4.64099 9.86209 4.66758 9.88894L5.27472 10.4961C5.33008 10.5514 5.42115 10.5514 5.47651 10.4961L6.86044 9.11216C7.85508 9.73894 9.18365 9.6193 10.0497 8.75323C11.0551 7.74787 11.0551 6.1193 10.0497 5.11394C9.04436 4.10858 7.41579 4.10858 6.41044 5.11394C5.54436 5.98001 5.42472 7.31037 6.05151 8.30323ZM7.21936 5.92287C7.77829 5.36394 8.68365 5.36394 9.24079 5.92287C9.79972 6.4818 9.79972 7.38716 9.24079 7.9443C8.68186 8.50323 7.77651 8.50323 7.21936 7.9443C6.66222 7.38537 6.66044 6.4818 7.21936 5.92287Z",
    fill: "white",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1467_17589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackSurfaceIcon);
export default __webpack_public_path__ + "static/media/Attack_Surface_Icon.0580977906b4b893df899e6f31abfead.svg";
export { ForwardRef as ReactComponent };